import { render, staticRenderFns } from "./SwitchingForm.vue?vue&type=template&id=07c2dbe4&"
import script from "./SwitchingForm.vue?vue&type=script&lang=js&"
export * from "./SwitchingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports